import { styled } from "styled-components";

export const PartnerForBusinessPageContainer = styled.div`
  .customCard {
    /* height: 250px; */
    @media (max-width: 991px) {
      border: none;
    }
    .wwaLeft {
      order: 0;
      .top-content {
        .title {
          font-size: 30px;
          font-weight: 600;
          @media (max-width: 991px) {
            font-size: 26px;
          }
          @media (max-width: 767px) {
            font-size: 22px;
          }
          @media (max-width: 575px) {
            font-size: 18px;
          }
        }
      }
      .sub-title {
        @media (max-width: 575px) {
          font-size: 12px;
        }
      }
      @media (max-width: 991px) {
        order: 1;
        margin-top: 20px;
      }
    }
    .wwaRight {
      order: 1;
      @media (max-width: 991px) {
        order: 0;
      }
      .img-side {
        text-align: center;
      }
    }
  }

  .partner-section {
    .title-section {
      border-bottom: 1px solid #e6e6e6;
      padding-bottom: 10px;
      .title {
        font-size: 30px;
        font-weight: 600;
        @media (max-width: 991px) {
          font-size: 26px;
        }
        @media (max-width: 767px) {
          font-size: 22px;
        }
        @media (max-width: 575px) {
          font-size: 18px;
        }
      }
    }

    .partner-content {
      display: flex;
      justify-content: center;
      align-items: flex-start;

      .partner-icon {
        margin-right: 20px;
        @media (max-width: 991px) {
          width: 45px;
          height: 45px;
        }
        @media (max-width: 767px) {
          width: 40px;
          height: 40px;
        }
        @media (max-width: 575px) {
          width: 36px;
          height: 36px;
        }
      }

      .content-title span {
        font-size: 22px;
        font-weight: 600;
        @media (max-width: 991px) {
          font-size: 20px;
        }
        @media (max-width: 767px) {
          font-size: 18px;
        }
        @media (max-width: 575px) {
          font-size: 14px;
        }
      }
      .content p {
        font-size: 18px;
        margin-bottom: 0;
        @media (max-width: 991px) {
          font-size: 16px;
        }
        @media (max-width: 767px) {
          font-size: 14px;
        }
        @media (max-width: 575px) {
          font-size: 12px;
          line-height: inherit;
        }
      }
    }
  }

  .brand-section {
    .brand-title {
      font-size: 30px;
      font-weight: 600;
      @media (max-width: 992px) {
        margin-top: 18px;
        margin-bottom: 18px;
        font-size: 28px;
      }
      @media (max-width: 767px) {
        margin-top: 0;
        margin-bottom: 12px;
        font-size: 19px;
      }
      @media (max-width: 575px) {
        font-size: 18px;
        margin-top: 0;
        margin-bottom: 12px;
      }
    }

    .brand-subtitle {
      p {
        font-size: 20px;
        margin-bottom: 0;
        @media (max-width: 767px) {
          font-size: 14px;
        }
        @media (max-width: 575px) {
          font-size: 12px;
        }
      }
    }
  }

  .title-offer {
    font-size: 30px;
    font-weight: 600;
    @media (max-width: 991px) {
      font-size: 26px;
    }
    @media (max-width: 767px) {
      font-size: 22px;
    }
    @media (max-width: 575px) {
      font-size: 18px;
    }
  }

  .section-no {
    background-color: #f0f7ff;
    border-radius: 12px;
    color: #024089;
    padding: 4px;
    @media (max-width: 991px) {
      font-weight: 700;
    }
  }
  .title {
    font-size: 22px;
    font-weight: 600;
    @media (max-width: 767px) {
      font-size: 20px;
    }
    @media (max-width: 575px) {
      font-size: 18px;
    }
  }

  .subtitle {
    font-size: 16px;
    @media (max-width: 575px) {
      font-size: 12px;
    }
  }

  .kplabel {
    @media (max-width: 420px) {
      font-size: 14px;
    }
  }

  .missionSection {
    background-color: #f0f7ff;
    padding: 30px 0;
    .kpt {
      padding: 20px 0;
      @media (max-width: 992px) {
        padding-top: 18px;
        padding-bottom: 18px;
      }
      @media (max-width: 767px) {
        padding-top: 18px;
        padding-bottom: 18px;
      }
      @media (max-width: 575px) {
        font-size: 18px;
        padding-top: 12px;
      }
      .title {
        text-align: center;
        font-size: 30px;
        font-weight: 600;
        @media (max-width: 992px) {
          font-size: 28px;
        }
        @media (max-width: 767px) {
          font-size: 22px;
        }
        @media (max-width: 575px) {
          font-size: 18px;
        }
      }
    }
    .kp {
      min-height: 100%;
      .cr-img {
        text-align: center;
        img {
          width: 57px;
          height: 57px;
          @media (max-width: 992px) {
            width: 47px;
            height: 47px;
          }
          @media (max-width: 575px) {
            width: 45px;
            height: 45px;
          }
        }
      }
      .cr-title {
        margin-top: 20px;
        margin-bottom: 20px;
        text-align: center;
        font-size: 30px;
        font-weight: 600;
        @media (max-width: 992px) {
          margin-top: 18px;
          margin-bottom: 18px;
          font-size: 28px;
        }
        @media (max-width: 767px) {
          margin-top: 0;
          margin-bottom: 12px;
          font-size: 20px;
        }
        @media (max-width: 575px) {
          font-size: 18px;
          margin-top: 0;
          margin-bottom: 12px;
        }
      }
      .cr-content {
        p {
          font-size: 16px;
          font-weight: 400;
          @media (max-width: 575px) {
            font-size: 12px;
          }
        }
      }
    }
  }
`;
